import { TokenComposeError } from '../errors';
import { IAstNode, IPathWithDirectionAstNode } from '../typings/ast-node';

export function validateAstNode(currentAstNode: IAstNode, parentAstNode: IAstNode | null): boolean {

  if (!currentAstNode) {
    return true;
  }

  const { withDirection, directionNode } = currentAstNode as IPathWithDirectionAstNode;

  if (withDirection) {
    const isValid = !!parentAstNode && parentAstNode.type === 'FunctionCall' && parentAstNode.value === 'DS_FIND' &&
      parentAstNode.args.findIndex(item => item === currentAstNode) === 2;

    if (!isValid) {
      throw new TokenComposeError('direction-at-wrong-place', directionNode.token.code + `只能在 ${(parentAstNode!.token as any).name} 的第三个参数中使用`, currentAstNode.token.position);
    }
    return true;
  }
  return currentAstNode.children ? currentAstNode.children.every(node => {
    return validateAstNode(node, currentAstNode);
  }) : true;
}
